module.exports = __webpack_public_path__ + "static/AvenirNextLTPro-HeavyCnIt-67ff8c2a475a98d2c1fe9a03c3c090f2.woff";